import { Navigate } from "react-router-dom";
import GlOutlet from "./pages/gl-outlet";
import GlAccounts from "./pages/gl-accounts";
import GlAccountDetail from "./pages/gl-account-detail";
import GlJournalEntry from "./pages/gl-journal-entry";

const GlRoutes = [
  {
    path: "/gl-management",
    element: <GlOutlet />,
    children: [
      {
        index: true,
        element: <Navigate to="accounts" replace />,
      },
      {
        path: "accounts",
        element: <GlAccounts />,
      },
      {
        path: "accounts/:glId",
        element: <GlAccountDetail />,
      },
      {
        path: "journal-entries",
        element: <GlJournalEntry />,
      },
    ],
  },
];

export default GlRoutes;
